import { Button } from '@bambi/component-library/src/components/Button/Button';

import { QRCode } from 'src/common/primitives/QRCode/QRCode';

interface QRCodeTabProps {
  url: string;
  onClose: () => void;
}
export function QRCodeTab({ url, onClose }: QRCodeTabProps) {
  return (
    <div>
      <div className="flex flex-row justify-center">
        <QRCode text={url} width={200} height={200} />
      </div>
      <div className="flex flex-row justify-end">
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  );
}
